<!--登录页-->
<template>
  <div class="el-login">
    <el-row style="padding: 10px 0;height: 100px;">
      <el-col :span="12" style="text-align: center;">
        <el-image :src="src"></el-image>
      </el-col>
        <el-col :span="12" style="line-height: 80px;text-align: center;">
          <el-link type="success" :underline="false" style="font-size: 30px;color: #79C48C;">常见问题</el-link>
        </el-col>
    </el-row>
    <el-row>
      <el-image :src="bg" style="width: 100%;height: 530px;"></el-image>
      <el-row class="login_box">
        <el-row class="login_input">
          <el-link type="primary" :underline="false" style="font-size: 30px;margin: 20px 0;">登录</el-link>
          <el-input
            placeholder="用户名"
            prefix-icon="el-icon-user"
            clearable
            :autofocus="userNameFocus"
            v-model="userName">
          </el-input>
          <el-input
            placeholder="密码"
            prefix-icon="el-icon-goods"
            clearable
            type="password"
            v-model="password">
          </el-input>
          <el-button type="primary" style="width: 100%;" @click="onSubmit">登录</el-button>
          <el-row style="padding: 10px 0;height: 100px;">
            <el-col :span="12" style="text-align: left;">
              <el-link type="primary" style="font-weight: bold;">忘记登陆密码？</el-link>
            </el-col>
            <el-col :span="12" style="text-align: right;">
               <el-checkbox style="font-weight: bold;color: #409EFF;" @change="changeAutoLogin" v-model="autoLogin">自动登录</el-checkbox>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
    <el-row style="padding:5px 0 5px 10%;">
      <el-image :src="notice" style="float: left;margin-right: 10px;"></el-image>
      <span style="color: rgb(167 163 163);font-size: 15px;">公告信息推送位置入口</span>
    </el-row>
    <el-row style="background-color: #F2F2F2;height: 10px;">
    </el-row>
    <el-row style="padding: 10px 0;margin-bottom: 40px;">
      <el-col :span="12" style="text-align: center;">
         <el-image :src="android" class="qRCode"></el-image>
         <el-row>扫码下载安卓APP</el-row>
      </el-col>
      <el-col :span="12" style="text-align: center;">
          <el-image :src="ios" class="qRCode"></el-image>
          <el-row>扫码下载苹果APP</el-row>
      </el-col>
    </el-row>
    <el-row style="background-color: #F2F2F2;text-align: center;padding: 10px;color: rgb(167 163 163);position: fixed;bottom: 0;width: 100%;">
      copyRight @版权所有 xxx技术学院
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue';
  import bg from '@/images/login/bg.png';
  import notice from '@/images/login/notice.png';
  import android from '@/images/login/android_cj.png';
  import ios from '@/images/login/android_cj.png';
  import {getStorageKeyForRoleTag} from "../common/ulit";
export default {
  name: "Login",
  data() {
    return {
      src:"",
      bg:bg,
      notice:notice,
      ios:ios,
      android:android,
      userName:"",
      password:"",
      userNameFocus:true,
      autoLogin: false
    };
  },
  created() {
    this.autoLogin = localStorage.getItem(getStorageKeyForRoleTag('autoLogin')) == "true"?true:false;
    this.userName = localStorage.getItem(getStorageKeyForRoleTag('userName')) || "";
    if(this.autoLogin && !this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag('TOKEN')))){
      window.location.href = window.location.origin + '/Home';
    }
  },
  methods: {
    changeAutoLogin(v){
      localStorage.setItem(getStorageKeyForRoleTag('autoLogin'),v);
    },
    onSubmit(){
      if(this.userName == ""){
         this.$message({
            message: '请输入用户名！',
            type: 'warning'
          });
        return;
      }
      if(this.password == ""){
        this.$message({
           message: '请输入密码！',
           type: 'warning'
        });
        return;
      }
      this.$store.dispatch("getPasswordLogin", {code:this.userName,password:this.password})
        .then((ret) => {
          if (ret.code === 0 || ret.code === '0') {
            //  TODO 这块没有做多账号
            console.info(ret);
            if(!this.$isEmpty(ret.JT_S_02_token)){
              localStorage.setItem(getStorageKeyForRoleTag('userName'),this.userName);
              this.$message({
                 message: '登录成功！',
                 type: 'success'
               });
              // 保存登录信息到到session 和 local
              //  TODO 这块没有做多账号
              for(var item in ret){
                  if(item.indexOf("JT_S") >= 0){ //item 表示Json串中的属性，如'name'
                      var jValue=ret[item];//key所对应的value
                      this.$cookies.set(item, jValue, 60*60*1);
                  }
              }
              localStorage.setItem(getStorageKeyForRoleTag('TOKEN'), ret.JT_S_02_token);
              window.location.href = window.location.origin + '/Home?_role_tag='+ret.loginTime;
            }else{
              this.$message({
                 message: "登录失败，用户名不存在或密码错误！",
                 type: 'warning'
              });
            }
          } else {
            this.$message({
               message: ret.msg,
               type: 'warning'
            });
          }
        });
    }
  }
};
</script>
<style  lang="less">
  @import '../styles/base.less';
  .el-main{
    background-color: #FFFFFF;
    padding: 0;
  }
  .el-login{
    min-width: 1200px;
    .qRCode{
      margin-right: 10px;border: 1px solid #000000;width: 150px;margin-top: 20px;padding: 5px;
    }
    .login_box{
      width: 360px;height: 440px;position: absolute;right: 120px;top: 50px;background-color: white;border-radius: 10px;
      .login_input{
        padding: 30px;
      }
      .el-input,.el-button{
        margin-top: 30px;
      }
      .el-button{
        margin-bottom: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue